import React from "react";
import { useIntl } from "react-intl";
import cn from "classnames";
import { Link } from "react-router-dom";

import Seo from "../../../../common/helpers/seo";

import routing from "../../../routing";

import { StyledTerms } from "./styles";

const Terms = () => {
    const { locale } = useIntl();
    return (
        <StyledTerms marginTop={50} as="section" className={cn("spring--shadow")}>
            <Seo title={locale === "hu" ? "Felhasználási feltételek" : "Terms of usage"} type="article" />
            <h1>FELHASZNÁLÁSI FELTÉTELEK</h1>
            <h2>1. A Weboldal használatára vonatkozó általános rendelkezések</h2>
            <p>
                A Musicators - digitális memorizálás webalkalmazást (a továbbiakban: Webalkalmazás) és az azzal összefüggő
                szolgáltatásokat (a továbbiakban együttesen: Weboldal, Szolgáltatás) Bali Dániel és Dr. Molnár Dániel (a
                továbbiakban együttesen: Szolgáltató) üzemelteti. Az itt leírt általános használati feltételek (a
                továbbiakban: Használati Feltételek) szabályozzák a jelen Szolgáltatással működtetett Webalkalmazás
                felhasználók által történő használatát. A Szolgáltatás bármely részéhez való hozzáférésével, illetve
                használatával Ön tudomásul veszi, hogy a jelen Használati Feltételekben foglalt rendelkezéseket, valamint
                azok esetleges jövőbeli módosításait elolvasta, megértette, és azokat kifejezetten önmagára nézve kötelező
                érvényűnek fogadja el. A Szolgáltatónak joga van a Használati Feltételek megváltoztatására, frissítésére,
                illetve kicserélésére – ilyen változtatás esetén a Felhasználót értesíti, mikor az legközelebb az oldalra
                érkezik, valamint feltünteti az érvényes Használati Feltételek utolsó frissítésének dátumát. Amennyiben Ön
                nem ért egyet a jelen Használati Feltételekben foglalt rendelkezések tartalmával, Ön nem jogosult a
                Szolgáltatáshoz való hozzáférésre, illetve annak használatára.
            </p>
            <h2>2. A Webalkalmazás és a Szolgáltatás leírása</h2>
            <p>
                A Webalkalmazás segítségével a Felhasználó csoportokat, azon belül gyakorlandó zeneműveket hozhat létre. A
                Webalkalmazás használata folyamán a Felhasználó hanganyagokat tölt fel, melyeket részekre oszthat, majd
                külön gyakorolhat, önértékelve tudását. A csoporthoz más Felhasználók is csatlakozhatnak és elérhetik a
                hanganyagokat, amennyiben rendelkeznek a csatlakozáshoz szükséges jelszóval. A jogszabályi háttér 14 éven
                aluli Felhasználók számára csak a nagykorú felügyeletével teszi lehetővé a Webalkalmazás használatát. Az
                adatvédelmi rendelkezésekről a továbbiakban olvashat.
            </p>
            <h2>3. Regisztráció</h2>
            <p>
                A Szolgáltatás igénybevételéhez szükséges regisztrációval a Felhasználó beleegyezik abba, hogy önmagáról
                pontos és aktuális információt köteles szolgáltatni – a regisztrációs kérdőívnek megfelelően; köteles
                gondoskodni a jelszavának, illetve a regisztrációval létrehozott profil biztonságához szükséges
                információknak bizalmasságáról; valamint a regisztrációval létrehozott profilban foglalt adatokat a
                valóságnak megfelelően folyamatosan frissíti.
            </p>
            <p>
                Szolgáltató a Szolgáltatás átmeneti vagy végleges szünetelése miatt, illetve a Szolgáltató által kezelt
                adatok részleges vagy teljes elvesztése miatt semmilyen felelősséget nem vállal.
            </p>
            <h2> 4. Szerzői jogok</h2>
            <p>
                A Weboldal egésze, annak grafikus elemei, szövege és technikai megoldásai, és a Szolgáltatás elemei szerzői
                jogi védelem vagy más szellemi alkotáshoz fűződő jog alatt állnak. Szolgáltató a szerzői jogi jogosultja
                vagy a feljogosított felhasználója a Weboldalon, valamint a Weboldalon keresztül elérhető szolgáltatások
                nyújtása során megjelenített valamennyi tartalomnak: bármely szerzői műnek, illetve más szellemi alkotásnak
                (ideértve többek közt valamennyi grafikát és egyéb anyagokat, a Weboldal felületének elrendezését,
                szerkesztését, a használt szoftveres és egyéb megoldásokat, ötletet, megvalósítást).
            </p>
            <p>
                A Weboldal tartalmának valamint egyes részeinek fizikai vagy más adathordozóra mentése vagy kinyomtatása
                magáncélú felhasználás céljából vagy a Szolgáltató előzetes írásbeli hozzájárulása esetén engedélyezett. A
                magáncélú felhasználáson túli felhasználás – például adatbázisban történő tárolás, továbbadás, közzé- vagy
                letölthetővé tétel, kereskedelmi forgalomba hozatal – kizárólag a Szolgáltató előzetes írásbeli engedélyével
                lehetséges.
            </p>
            <p>
                A jelen Használati Feltételekben kifejezetten meghatározott jogokon túlmenően a regisztráció, a Szolgáltatás
                használata, illetve a Használati Feltételek egyetlen rendelkezése sem biztosít jogot a Felhasználónak a
                Weboldalon szereplő bármely kereskedelmi névnek vagy védjegynek bármely használatára, hasznosítására. A
                Szolgáltatás rendeltetésszerű használatával járó megjelenítésen, az ehhez szükséges ideiglenes
                többszörözésen és a magáncélú másolatkészítésen túl e szellemi alkotások a Szolgáltató előzetes írásbeli
                engedélye nélkül semmilyen egyéb formában nem használhatók fel vagy hasznosíthatók.
            </p>
            <h2>5. Adatvédelem</h2>
            <p>
                A Szolgáltatás igénybevételére, illetve használatára vonatkozó magatartási szabályok a Weboldalon elérhető
                Adatvédelmi Szabályzat hatálya alá is tartoznak, amely{" "}
                <Link className={"link"} to={"/" + routing.memory + "/" + routing.privacy}>
                    ide kattintva
                </Link>{" "}
                érhető el. A Szolgáltatás használatával a Felhasználó elfogadja az Adatvédelmi Szabályzatban foglaltakat is.
            </p>
            <h2>6. A Weboldalon a Felhasználó által feltöltött tartalom</h2>
            <h3>6.1. Zeneművek és hangfelvételek szerzői jogsértének kezelése</h3>
            <p>
                A Weboldalon az egyes szolgáltatások megfelelő igénybevételéhez szükséges lehet hanganyag feltöltése. A
                Felhasználónak kötelessége garantálni, hogy a feltöltés és ennek következtében a hanganyag tárolása nem von
                maga után jogsértést sem a zeneszerzőt, sem a lemezkiadót illetően. A feltöltött tartalmakat bizonyos
                időközönként átvizsgálhatjuk és jogsértés gyanúja esetén a tartalmat a lehető leghamarabb eltávolítjuk.
                Rendszeres próbálkozás jogi lépéseket vonhat maga után, illetve fenntartjuk a jogot, hogy ennek
                következtében a Felhasználó fiókját deaktiváljuk.
            </p>
            <p>Utoljára frissítve: 2019. július. 22.</p>
        </StyledTerms>
    );
}

export default Terms;
